import { SpriteTypes, spriteCategory } from '../types/sprite-types'
import { uuid } from '@/libs/src/utils/tools'

const options = {
    width: 100,
    height: 100,
    lineWidth: 0,
    imageRatio:true,
    visible: true,
    isBottom:true,disableAnchor:true,
}
export default [
    {
        id: uuid(),
        name: "水池",
        type: SpriteTypes.sprite,
        image: "images/technology/14.png",
        categrory: spriteCategory.pool,
        data: {
            image: "images/technology/14.png",
            ...options,
            text: "Text",
            dropdownList: [
                { text: 1, a: "a" },
                { text: 2, a: "b" },
            ]
        },
    },
    {
        id: uuid(),
        name: "沉砂池",
        type: SpriteTypes.sprite,
        image: "images/technology/15.png",
        categrory: spriteCategory.pool,
        data: {
            image: "images/technology/15.png",
            width: 100,
            height: 100,
            name: "image",
            ...options
        },
    },
    {
        id: uuid(),
        name: "泥土背景",
        type: SpriteTypes.sprite,
        image: "images/technology/16.png",
        categrory: spriteCategory.pool,
        data: {
            image: "images/technology/16.png",
            width: 100,
            height: 100,
            name: "image",
            ...options
        },
    },
    {
        id:uuid(),
        name: "罐体",
        type: SpriteTypes.sprite,
        image: "images/technology/17.png",
        categrory: spriteCategory.accessories,
        data: {
            image: "images/technology/17.png",
            width: 100,
            height: 100,
            name: "image",
            ...options
        },
    },
    {
        id: uuid(),
        name: "水位",
        type: SpriteTypes.sprite,
        image: "images/technology/18.png",
        categrory: spriteCategory.accessories,
        data: {
            image: "images/technology/18.png",
            width: 100,
            height: 100,
            name: "image",
            ...options
        },
    },
    {
        id:uuid(),
        name: "栅格间",
        type: SpriteTypes.sprite,
        image: "images/technology/19.png",
        categrory: spriteCategory.accessories,
        data: {
            image: "images/technology/19.png",
            width: 100,
            height: 100,
            name: "image",
            ...options
        },
    },
    {
        id: uuid(),
        name: "格栅渠",
        type: SpriteTypes.sprite,
        image: "images/technology/20.png",
        categrory: spriteCategory.accessories,
        data: {
            image: "images/technology/20.png",
            width: 100,
            height: 100,
            name: "image",
            ...options
        },
    },
    {
        id: uuid(),
        name: "贝斯柜体",
        type: SpriteTypes.sprite,
        image: "images/technology/21.png",
        categrory: spriteCategory.accessories,
        data: {
            image: "images/technology/21.png",
            width: 100,
            height: 100,
            name: "image",
            ...options
        },
    },
    {
        id: uuid(),
        name: "污泥浓缩池",
        type: SpriteTypes.sprite,
        image: "images/technology/22.png",
        categrory: spriteCategory.accessories,
        data: {
            image: "images/technology/22.png",
            width: 100,
            height: 100,
            name: "image",
            ...options
        },
    },
    {
        id: uuid(),
        name: "池体",
        type: SpriteTypes.sprite,
        image: "images/technology/pool1.png",
        categrory: spriteCategory.accessories,
        data: {
            image: "images/technology/pool1.png",
            width: 100,
            height: 100,
            name: "image",
            ...options
        },
    },
    {
        id: uuid(),
        name: "池体",
        type: SpriteTypes.sprite,
        image: "images/technology/23.png",
        categrory: spriteCategory.accessories,
        data: {
            image: "images/technology/23.png",
            width: 100,
            height: 100,
            name: "image",
            ...options
        },
    },
]